const pageTranslate =  {
    init() {
        let self = this;
        self._construct();
    },

    _construct() {
        let bodyNode = document.querySelector('body');
        
       
        

        let script = document.createElement('script');
        script.setAttribute('type', 'text/javascript');
        script.setAttribute('src', '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit');
        bodyNode.prepend(script);

        let fnc = document.createElement('script');
        fnc.setAttribute('type', 'text/javascript');
        fnc.innerHTML = "function googleTranslateElementInit() {new google.translate.TranslateElement({pageLanguage: 'cs', layout: google.translate.TranslateElement.InlineLayout.HORIZONTAL}, 'google_translate_element');}";
        bodyNode.prepend(fnc);

        let node = document.createElement('div');
        node.id = "google_translate_element";
        bodyNode.prepend(node);

        document.querySelector('header').style.top = '40px';
        document.querySelector('main').setAttribute('style', 'position:relative;top:40px;');
       // <script type="text/javascript">function googleTranslateElementInit() {new google.translate.TranslateElement({pageLanguage: 'cs'}, 'google_translate_element');}</script>

        //<script type="text/javascript" src="//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"></script>
    }
}


window.pageTranslate = pageTranslate;